import { deviceWord } from '@littlebird/ui-utils';
import { format } from 'date-fns/format';
import { isToday } from 'date-fns/isToday';
import { isTomorrow } from 'date-fns/isTomorrow';

import { formatTime } from '@/utils/date';

const MILLISECONDS_PER_MINUTE = 60_000;

const formatDay = (date: Date) => format(date, 'EEE d MMM');

/** When a waiting run gives up on its device: "11:01 PM", "tomorrow at 7:00 AM" */
export const formatDeadline = (date: Date) => {
  if (date.getTime() - Date.now() < MILLISECONDS_PER_MINUTE) {
    return 'any moment now';
  }
  if (isToday(date)) return formatTime(date);
  if (isTomorrow(date)) return `tomorrow at ${formatTime(date)}`;
  return `${formatDay(date)} at ${formatTime(date)}`;
};

export const formatDeviceTime = (date: Date) =>
  isToday(date) ? formatTime(date) : `${formatDay(date)}, ${formatTime(date)}`;

export const RESTART_WAITING_RUN_COPY = {
  button: 'Restart with new instructions',
  confirmTitle: 'Restart this run?',
  confirmBody: (devices: readonly { platform: string }[]) =>
    `The waiting run stops and the routine runs again now with your new instructions. Anything the run already did stays done. ${
      devices.length === 1
        ? `If ${deviceWord(devices[0].platform)} is still offline, the new run finishes without it.`
        : 'If those devices are still offline, the new run finishes without them.'
    }`,
  confirmButton: 'Restart',
  cancelButton: 'Keep waiting',
  failure: 'Could not restart the run. Try again.',
};
